import React from 'react'
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import MetaTags from "react-meta-tags";

//images import
import notFoundImage from '../../assets/images/404-error.png';

const NotFound = () => {
    return (
        <React.Fragment>

            <MetaTags>
                <title>404 | {process.env.REACT_APP_TITLE}</title>
            </MetaTags>
                <div className="auth-page-content">
                    <Container>
                        <Row style={{
                            marginTop: '100px',
                        }}>
                            <Col lg={12}>
                                <div className="text-center mt-5 pt-4">
                                    <div className="mb-5 text-white-50">
                                        <h1 className="display-5 coming-soon-text">Essa página não foi encontrada</h1>
                                        <div className="mt-4 pt-2">
                                            <Link to="/" className="btn btn-primary"><i className="mdi mdi-home me-1"></i> Ir para o dashboard</Link>
                                        </div>
                                    </div>
                                    <Row className="justify-content-center mb-5">
                                        <Col xl={4} lg={8}>
                                            <div>
                                                <img src={notFoundImage} alt="" className="img-fluid" />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
        </React.Fragment>
    )
}

export default NotFound;